<template>
  <div class="secondary-menu create-event club" v-if="clubOriginal">
    <div class="secondary-menu-header">
      <i class="back" @click="openClub(clubOriginal.id, 'club')"></i>
      <div class="title">{{ trans('edit') }}</div>
      <i class="trash" @click="removeClub(club.id)"></i>
    </div>
    <div class="secondary-menu-body" id="scroll-club">
      <div class="tab-content-wrapper event-category-tabs">
        <div class="tab-content-inner">
          <div class="tab-content">
            <div>
              <form novalidate data-vv-scope="form1" @submit.prclub>
                <div class="center">
                  <input type="hidden" name="type" v-model="type" v-validate="{required: true}" />
                  <div class="name-edit">
                    <label>
                      <input type="text" v-bind:placeholder="trans('title')" maxlength="50" v-bind:data-vv-as="trans('title')" :required="titleRequired" v-model="title" v-validate="{required: titleRequired}" :class="{'is-invalid-input': errors.has('form1.title')}" name="title">

                      <span class="form-error" :class="{'is-visible': errors.has('form1.title')}">
												{{ errors.first('form1.title') }}
											</span>
                    </label>
                  </div>
                  <div class="box">
                    <div id="club-main-pic" class="profile-main-pic" @click.self="openGallery('clear', true)">
                      <div class="img" v-if="!defaultEventPhoto.match(/default_180x180/)"
                           :style="{'background': defaultEventPhoto}">
                      </div>
                      <div v-if="!defaultEventPhoto.match(/default_180x180/)"
                           @click.stop="clearAvatar('clear', true)" class="close">
                      </div>
                      <div v-if="defaultEventPhoto.match(/assets\/img\/toohot_/)  || defaultEventPhoto.match('img\/prohibited')" class="spinner-container">
                        <img class="preloader"
                             src="/assets/img/preloader.svg"
                             alt="">
                      </div>
                    </div>
                  </div>
                  <PhotoGallery/>
                  <div class="box description-link">
                    <div class="row">
                      <div class="headline">Description</div>
                      <textarea class="description"
                                maxlength="510"
                                name="description" v-bind:placeholder="trans('club_description')"
                                v-bind:data-vv-as="trans('club_description')" required
                                v-model="description" v-validate="'required'"
                                :class="{'is-invalid-input': errors.has('form1.description')}"
                                rows="3">
											</textarea>

                      <span class="form-error" :class="{'is-visible': errors.has('form1.description')}">
												{{ errors.first('form1.description') }}
											</span>
                    </div>
                  </div>

                  <div class="box handle">
                    <span class="handle-icon">@</span>
                    <label>
                      <input type="text"
                             placeholder="web address"
                             v-bind:data-vv-as="trans('handle')"
                             v-model="handle"
                             @blur="checkLink"
                             :class="{'is-invalid-input': errors.has('form1.handle')}"
                             name="handle"
                      >
                      <span class="form-error" :class="{'is-visible': errors.has('form1.handle')}">
                            {{ errors.first('form1.handle') }}
                          </span>
                    </label>
                  </div>
                  <div class="box website">
                    <span class="website-icon"></span>
                    <label @click="() => { this.userIsPro ? () => {} : this.requirementsAlertShow('clubs_website') }">
                      <input type="text"
                             placeholder="web address"
                             v-bind:data-vv-as="trans('website')"
                             v-model="website"
                             :class="{'is-invalid-input': errors.has('form1.website')}"
                             name="website"
                             :disabled="!userIsPro"
                      >
                      <span class="form-error" :class="{'is-visible': errors.has('form1.website')}">
                          {{ errors.first('form1.website') }}
                        </span>
                    </label>
                  </div>
                  <div class="box invitiation">
                    <div class="row">
                      <div class="toggle_label">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M22.5 10H21.25V7.5C21.25 4.05 18.45 1.25 15 1.25C11.55 1.25 8.75 4.05 8.75 7.5V10H7.5C6.125 10 5 11.125 5 12.5V25C5 26.375 6.125 27.5 7.5 27.5H22.5C23.875 27.5 25 26.375 25 25V12.5C25 11.125 23.875 10 22.5 10ZM15 21.25C13.625 21.25 12.5 20.125 12.5 18.75C12.5 17.375 13.625 16.25 15 16.25C16.375 16.25 17.5 17.375 17.5 18.75C17.5 20.125 16.375 21.25 15 21.25ZM11.25 10V7.5C11.25 5.425 12.925 3.75 15 3.75C17.075 3.75 18.75 5.425 18.75 7.5V10H11.25Z" fill="#9D9D9D"/>
                        </svg>
                        <div class="title private-switch">
                          {{ trans('clubs.invitation_only_club') }}
                        </div>
                      </div>
                      <div class="field">
                        <div class="toggle-switch" @click="onPrivateToggleClick">
                          <input type="checkbox" id="is_private"
                                  v-model="is_private"
                                  :disabled="force_private"
                                  true-value="1"
                                  false-value="0"
                                  name="is_private">
                          <label for="is_private">
                            <span class="toggle-track"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="box hide_admin">
                    <div class="row">
                      <div class="toggle_label">
                        <svg style="margin-left:5px;" width="22" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14.3a1 1 0 0 1 1.41 0l18 18a1 1 0 1 1-1.41 1.4l-3.16-3.15A10.1 10.1 0 0 1 10.84 18c-2.86 0-5.19-1.26-6.92-2.7a17.73 17.73 0 0 1-3.5-4.05l-.03-.04c-.11-.19-.27-.43-.34-.76a2.16 2.16 0 0 1 0-.9c.07-.33.23-.57.35-.76l.02-.04c.6-.95 1.83-2.67 3.62-4.14l-2.9-2.9a1 1 0 0 1 0-1.42ZM7.4 7.96A3.99 3.99 0 0 0 10.84 14c.75 0 1.44-.2 2.04-.55l-1.52-1.52a2 2 0 0 1-2.45-2.45L7.4 7.97Z" fill="#9D9D9D"/>
                          <path d="M14.84 9.75a4 4 0 0 0-3.75-3.74L7.64 2.55a9.68 9.68 0 0 1 3.2-.55c2.87 0 5.2 1.26 6.93 2.7a17.73 17.73 0 0 1 3.5 4.05l.02.04c.12.19.27.43.35.76.06.28.06.62 0 .9-.08.33-.23.57-.35.76l-.02.04a18.4 18.4 0 0 1-2.16 2.78l-4.27-4.28Z" fill="#9D9D9D"/>
                        </svg>
                        <div class="title private-switch">
                          {{ trans('clubs.hide_club_admin') }}
                        </div>
                      </div>
                      <div class="field">
                        <div class="toggle-switch">
                          <input type="checkbox"
                                 id="hide_admin"
                                 v-model='hide_admin'
                                 true-value="1"
                                 false-value="0"
                                 name="hide_admin" />
                          <label for="hide_admin">
                            <span class="toggle-track"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box location">
                    <div class="row">
                      <div class="title">{{ trans('location') }}</div>
                      
                      <div class="detail location notranslate" v-if="addressShow">{{ addressShow }}
                        <span class="form-error" :class="{'is-visible': addressError}">
                        {{ addressError }}
                      </span>
                      </div>
                    </div>
                  </div>
                  <div class="address" v-if="mapVisible" :class="{'show': mapVisible}">
                    <div class="input-wrapper">
                      <label>
                        <input
                            v-if="mapVisible"
                            class="form-control"
                            type="text"
                            name="address"
                            :placeholder="trans('club_address')"
                            :data-vv-as="trans('address')"
                            v-model="address"
                            v-validate="'required'"
                            :class="{'is-invalid-input': errors.has('form1.address')}"
                            @input="handleAddressModification"
                            required/>
                      </label>
                    </div>
                    <div v-if="mapVisible" class="map-box" id="map-box">
                      <Map
                          :lat="lat"
                          :lng="lng"
                          :zoom="15"
                          styles="height: 450px"
                          :clickable="true"
                          :draggable="true"
                          :dragEnd="handleMapMarkerDrag"/>
                      <div class="float-button">
                        <button class="btn set-location" @click="setLocation">{{ trans('set_location') }}</button>
                      </div>
                    </div>
                  </div>
                  <button class="btn publish" id="button6" type="button" @click="updateClub">
                    {{ trans('save') }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';
    import clubsModule from "@clubs/module/store/type";
    import PhotoSlider from '@clubs/views/widgets/club/create/media/PhotoSlider.vue'
    import VideoSlider from '@clubs/views/widgets/club/create/media/VideoSlider.vue'
    import PhotoGallery from '@clubs/views/widgets/club/create/media/PhotoGallery.vue'
    import VideoGallery from '@clubs/views/widgets/club/create/media/VideoGallery.vue'
    import Map from '@buddy/views/widgets/Map.vue';
    import moment from "moment";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-clubs').default,
            require('@general/lib/mixin-club-edit').default
        ],
        data() {
            return {
                id: null,
                title: '',
                club_date: '', //this needs moment globally for vee-validate to work
                time: '',
                handle: '',
                description: ``,
                location: '',
                address_type: 'full_address',
                address: '',
                addressShow: '',
                addressError: false,
                tags: [],
                website: '',
                newTag: "",
                type: null,
                chemsfriendly: false,
                is_profile_linked: false,

                lat: 52.520389,
                lng: 13.40424,

                locality: 'Berlin',
                state: 'Berlin',
                country: 'Germany',
                country_code: 'DE',

                //inner components variables
                mapVisible: true,
                mapFirstTime: true,
                //selected photos for club
                selectedPhotos: [],
                selectedVideos: [],
                deletedPhotos: [],
                defaultEventPhoto: 'url("/assets/img/default_180x180.jpg") center / cover',
                photos: [],

                //slim
                croppers: [],
                editPhotoId: null,
                slimOptions: this.defaultSlimOptions(),
                preview_photo: [],
                date: 'today',

                is_private: false,
                hide_admin: false,
                force_private: false
            }
        },
        components: {
            Map,
            DatePickerComponent,
            PhotoGallery,
            VideoGallery,
            PhotoSlider,
            VideoSlider,
        },
        computed: {
            clubOriginal(){
                return this.$store.getters.getClub(this.clubData.clubId)
            },
            ...mapGetters({
              clubData: clubsModule.getters.club
            }),
            defaultAvatar(){
                let user = this.$store.state.profile;
                return user.avatars && user.avatars.default
            },
            adultAvatar(){
                let user = this.$store.state.profile;
                return user.avatars && user.avatars.adult
            },
            titleRequired() {
              return true;
            },
            minDate(){
              return this.todayDate();
            },
        },
        mounted() {
            this.mapVisible = true

            console.log('[Edit Cub mobile] Mounted', {
                clubId: this.club.id,
                club: this.club
            })

            if (!!parseInt(this.club.id)) {
                this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.club.id,edit:1}).then(() => {
                  this.loadClubInfo();
                });
            }
            this.loadClubInfo();

        },
        methods: {
            loadClubInfo(){
              if (!!this.clubOriginal) {
                this.selectedPhotos = [];
                this.reset()
                this.prepareData(this.clubOriginal);
                this.hide_admin = this.club.hide_admin ? 1 : 0;
                this.is_private = this.club.is_private ? 1 : 0;
                this.force_private = !!this.club.force_private;
              }
            },
            onPrivateToggleClick(e) {
              if (this.force_private) {
                if (e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
                this.showErrorNotification('clubs.write_to_support_to_open_club');
              }
            },
            changeInvitationOnly(club) {
              let val = club.target.value;
              // ..
            },
            checkDeletePhoto(photoId) {
              const filterId = this.deletedPhotos.filter((filter) => {
                return filter === photoId;
              });

              if (filterId) {
                this.removeByValue(this.deletedPhotos, photoId);
              }
            },
            removeByValue(arr) {
              let what, a = arguments, length = a.length, ax;
              while (length > 1 && arr.length) {
                what = a[--length];
                while ((ax = arr.indexOf(what)) !== -1) {
                  arr.splice(ax, 1);
                }
              }
              return arr;
            },
            prepareData(data) {
                const self = this;
                for (let key in data) {
                  if (key === 'photos') {
                    data[key].forEach(function (photo) {
                      if (data.photo_small === photo.photo_small) {
                        self.defaultEventPhoto = `url(${photo.photo_small}) center / cover`;
                        self.preview_photo = photo;
                      } else {
                        self.photos.push(photo);
                      }
                    });
                  } else {
                    if (key === "club_date") {
                      this.date = "custom";
                    }
                    this[key] = data[key];
                  }
                }
            },
            defaultEventBackground(data) {
              if (data) {
                let photo = data[0];
                this.defaultEventPhoto = `url(${photo.photo_small}) center / cover`
                photo.is_default = 'yes';
                this.preview_photo = photo;
              }
            },
            setLocation() {
              this.mapVisible = false;
            },
            setPhotos(data) {
              this.photos.push(data);
              this.selectedPhotos.push(data.id);
            },
            setDeletePhotos(data, index) {
              this.deletedPhotos.push(data.id);
              this.selectedPhotos.splice(index, 1);
              this.photos.splice(index, 1);
            },
            addTag() {
              let tagValue = _.trimStart(this.newTag, '# ');
              tagValue = _.trimEnd(tagValue, ' ');
              if (!tagValue) {
                return;
              }

              this.newTag = '';
              axios.post('/api/tags/add', {name: tagValue})
                  .then(({data}) => {
                    if (data) {
                      this.user.tags.push(data);
                    }
                  })
            },
            deleteTag(tag) {
              const index = this.user.tags.indexOf(tag);
              const removedArray = this.user.tags.splice(index, 1);
              axios.post('/api/tags/delete', {id: tag.id})
                  .catch((error) => {
                    this.user.tags.splice(index, 0, removedArray[0]);
                  });
            },
            clearAvatar(slot) {
              let photo = this.preview_photo;

              app.$emit('avatar-preloader', { slot, value: true })
              this.defaultEventPhoto = 'url("/assets/img/default_180x180.jpg") center / cover';
              this.preview_photo = [];
              this.deletedPhotos.push(photo.id)
              app.$emit('avatar-preloader', { slot, value: false })
              if(!this.profilePhotos.some(data => data.id === photo.id)){
                photo.active = 0;
                this.profilePhotos.unshift(photo);
                this.$store.state.profilePhotos = this.profilePhotos.sort((b, a) => a.id - b.id);
              }
            },
            setType(type) {
              if (this.type !== type) {
                return;
              }
              this.type = type
            },
            openGallery(slot, defaultImg = false) {
              console.log(slot)
              app.$emit('show-photo-event-gallery', slot, defaultImg)
            },
            async handleMapMarkerDrag(club) {
              let newLat, newLng;

              if (this.mapProviderIsGmap) {
                newLat = club.latLng.lat();
                newLng = club.latLng.lng();
              } else {
                newLat = club.target.getLatLng().lat;
                newLng = club.target.getLatLng().lng;
              }

              try {
                let fullInfo = await this.getAddressForLatLng(newLat, newLng, true);
                this.lat = newLat;
                this.lng = newLng;
                this.location_type = 'manual';
                this.address = fullInfo.formattedAddress;
                this.locality = fullInfo.locality;
                this.state = fullInfo.state;
                this.country = fullInfo.country;
                this.country_code = fullInfo.country_code;
                this.addressError = null
              } catch(e) {
                this.addressError = e
              }
            },
            handleAddressModification: _.debounce(async function (club){
              let lat, lng;
              if (!club.target.value) {
                return;
              }

              try {
                //update map marker
                this.addressShow = 'Location defining...';
                let fullInfo = await this.getLatLngForAddress(this.address, true);
                this.addressShow = this.address;
                ({lat, lng} = fullInfo.point);
                this.lat = parseFloat(lat);
                this.lng = parseFloat(lng);
                this.location_type = 'manual';
                this.locality = fullInfo.locality;
                this.state = fullInfo.state;
                this.country = fullInfo.country;
                this.country_code = fullInfo.country_code;
                let v = this
                setTimeout(function() {
                  v.zoom = 15
                }, 500)
                this.addressError = null
              } catch(e) {
                this.addressError = e
              }
            }, 1000),

            async checkLink(){
              let checklink = await this.$store.dispatch('checkUserLink',{handle: this.handle, type:'event', id: this.id});
              if(!checklink.data.success){
                this.errors.add({
                  field: 'form1.handle',
                  msg: 'Current link is used. You can use this: ' + checklink.data.links_suggestions.join(', ')
                });
              }else{
                this.errors.remove('form1.handle')
              }
            },
            async updateClub() {
              this.$validator.validate();
              this.checkLink();
              let club = _.pick(this, [
                'id', 'title', 'description', 'handle', 'club_date', 'type', 'chemsfriendly',
                'is_profile_linked', 'time', 'location', 'locality', 'state',
                'country', 'country_code', 'address', 'lat', 'lng', 'address_type',
                'tags', 'preview_photo', 'deletedPhotos', 'is_private', 'website', 'hide_admin'
              ])
              club.photos = this.selectedPhotos;
              club.videos = this.selectedVideos;
              club.chemsfriendly = club.chemsfriendly ? 1 : 0;

              this.showLoadingButton('#button6')

              this.saveClub(club)
                  .then(() => {
                    this.restoreLoadingButton('#button6')
                  }).catch(() => {
                this.restoreLoadingButton('#button6')
              })
            },
            setDate(dateType) {
              if (dateType === 'today') {
                this.date = 'today';
                this.club_date = moment().format('YYYY-MM-DD')
              } else if (dateType === 'tomorrow') {
                this.date = 'tomorrow';
                this.club_date = moment().add(1, 'day').format('YYYY-MM-DD')
              }
            }
        }
    }
</script>
